import React from 'react';

const SacredFamily = () => (
  <div className="card-temple mb-12">
    <h3 className="text-2xl font-bold text-saffron mb-6 text-center">
      The Sacred Family
    </h3>
    
    <div className="text-center mb-6">
      <img
        src="https://customer-assets.emergentagent.com/job_ef1b1145-f8f0-4391-9cb1-5b2f821776b0/artifacts/0ku5jtyy_krishnaimage.png"
        alt="Ulsava Murtis of Sree Krishnaswamy temple"
        className="mx-auto max-w-full h-auto rounded-lg shadow-temple lotus-border"
      />
    </div>
    
    <div className="grid md:grid-cols-2 gap-8 items-center">
      <div>
        <p className="text-lg text-gray-700 mb-6 leading-relaxed">
          The main deity is <strong>Sree Krishnaswamy gracing the shrine with <strong>Rukmini</strong> and <strong>Satyabhama</strong></strong>.
        </p>
        <p className="text-gray-700 mb-4 leading-relaxed">
          The main idol—carved from dark, sacred <strong>Krishnashila</strong> stone—was consecrated on the{' '}
          <strong>Makayiram star of the 13th Day of Edavam in 1024 ME</strong>, depicting the divine family 
          in all their glory.
        </p>
        <p className="text-gray-700 leading-relaxed">
          In addition, <strong>Sri A. Janardhana Rao of Perumbilli Padinjare Madom</strong> donated a beautiful{' '}
          <strong>Panchaloha idol of Goddess Mahalakshmi</strong> for use during festivals and special days.
        </p>
      </div>
    </div>
    
    <div className="grid md:grid-cols-2 gap-8 mt-8">
      <div className="text-center">
        <img
          src="https://customer-assets.emergentagent.com/job_devaswom-preview/artifacts/0nbnf0cz_20251206_193849_0000.png"
          alt="Sacred family deity"
          className="mx-auto max-w-full h-auto rounded-lg shadow-temple lotus-border"
        />
      </div>
      <div className="text-center">
        <img
          src="https://customer-assets.emergentagent.com/job_devaswom-preview/artifacts/ahbxw4ah_20251206_212814_0000.png"
          alt="Sacred family deity"
          className="mx-auto max-w-full h-auto rounded-lg shadow-temple lotus-border"
        />
      </div>
    </div>
  </div>
);

export default SacredFamily;
